import React from 'react';
import PropTypes from 'prop-types';

import { Stack } from '@mui/material';

import CardLayout from '../../../Components/CardLayout';
import { COLORS } from '../../../Constant/COLORS';
import { TypoPoppBlue, TypoPoppins } from '../../../Components/Typo';

const overallComment = {
  Good: 'Good',
  Poor: 'Poor',
};

const CommentsCard = ({
  name,
  jobId,
  date,
  overallComments,
  review,
  ...rest
}) => (
  <CardLayout>
    <Stack gap={2} justifyContent='space-between' {...rest}>
      <TypoPoppBlue variant='body1' fontWeight={600} mr={5}>
        {name}
      </TypoPoppBlue>

      <TypoPoppins>
        Job ID : <span>{jobId}</span>
      </TypoPoppins>

      <TypoPoppins>
        Event Date : <span>{date}</span>
      </TypoPoppins>
      <TypoPoppins>
        Overall comments :{' '}
        <span
          style={{
            color:
              overallComments === overallComment.Good
                ? COLORS.green4
                : COLORS.red2,
          }}
        >
          {overallComments}
        </span>
      </TypoPoppins>

      <Stack direction='row'>
        <TypoPoppins display='inline' flexShrink={0}>
          Review :&nbsp;
        </TypoPoppins>
        <TypoPoppins display='inline'>{review}</TypoPoppins>
      </Stack>
    </Stack>
  </CardLayout>
);

CommentsCard.propTypes = {
  name: PropTypes.string.isRequired,
  jobId: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  overallComments: PropTypes.oneOf(Object.values(overallComment)).isRequired,
  review: PropTypes.string.isRequired,
};

export default React.memo(CommentsCard);
